import { useEffect } from 'react';

/**
 * GoogleAnalytics Component
 * Dynamically loads Google Analytics (gtag.js) and Google Ads conversion tracking
 * Supports both GA4 (G-XXXXXXXXXX) and Google Ads (AW-XXXXXXXXXX) tags
 */
const GoogleAnalytics = ({ measurementId }) => {
  useEffect(() => {
    if (!measurementId || measurementId.trim() === '') {
      return;
    }

    // Initialize dataLayer BEFORE loading script
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag;
    
    gtag('js', new Date());

    // Check if script already exists
    const existingScript = document.querySelector(`script[src*="googletagmanager.com/gtag/js?id="]`);
    
    if (!existingScript) {
      // Create and inject gtag script
      const script = document.createElement('script');
      script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
      script.async = true;
      
      script.onload = () => {
        console.log(`✅ Google Tag loaded successfully: ${measurementId}`);
        // Configure the tag after script loads
        if (window.gtag) {
          window.gtag('config', measurementId);
        }
      };
      
      script.onerror = () => {
        console.error(`❌ Failed to load Google Tag: ${measurementId}`);
      };
      
      document.head.appendChild(script);
    } else {
      // Script exists, just configure this ID
      console.log(`Google Tag script already loaded, configuring: ${measurementId}`);
      gtag('config', measurementId);
    }

  }, [measurementId]);

  return null;
};

export default GoogleAnalytics;
